import BloomiesSettings from '../organisms/BloomiesSettings';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';
import { BloomerSettings } from '../organisms/BloomerSettings';
import { Auth0User, Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';

const Settings = () => {
  const auth = useAuthStore((state) => state.auth);
  let user: Auth0User | undefined | null;
  if (auth) {
    user = auth.user;
  }

  return (
    <>
      {user?.roles?.includes(Role.Admin) && <BloomiesSettings />}
      {user?.roles?.includes(Role.Bloomer) && <BloomerSettings />}
    </>
  ) as React.ReactNode;
};

export default WithErrorBoundary(Settings);
